import React from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";

import ClearIcon from "@mui/icons-material/Clear";
import LoaderSpin from "../../Commons/LoaderSpin";

import TextStyles from "../../../../Constants/TextStyles";

import { Modal } from "react-bootstrap";
import Colors from "../../../../Constants/Colors";
import SelectCountry from "../../Commons/SelectCountry";
import Constant from "../../Commons/Constant";
import { invoiceActions } from "../../../../store/storage/invoiceSlice";

const EditClientInfo = ({ client_id, show, handleClose }) => {
  const isLoading = useSelector((state) => state.invoices.isLoading);
  const dispatch = useDispatch();
  const {
    register,
    reset,
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      street: client_id && client_id.street,
      suite: client_id && client_id.suite,
      city: client_id && client_id.city,
      zip_code: client_id && client_id.zip_code,
      country:
        client_id &&
        client_id.country &&
        Constant.countryOptions.filter(
          (data) => data.name === client_id.country
        )[0],
      state: client_id && client_id.state,
      tax_id_label: client_id && client_id.tax_id_label,
      tax_id_number: client_id && client_id.tax_id_number,
    },
  });

  const formsubmit = (data) => {
    const Obj = {
      zip_code: data.zip_code,
      street: data.street,
      suite: data.suite,
      city: data.city,
      country: data.country ? data.country.name : null,
      state: data.state,
      tax_id_label: data.tax_id_label,
      tax_id_number: data.tax_id_number,
    };
    dispatch(
      invoiceActions.selectedInvoiceAction({
        client_id: {
          ...client_id,
          ...Obj,
        },
      })
    );
    reset();
    handleClose();
  };

  return (
    <div>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ToMakeModalOnRight500px"
        fullscreen
      >
        <form
          onSubmit={handleSubmit(formsubmit)}
          className="modal-content"
          style={{ height: "100%" }}
        >
          <Modal.Header className="d-flex align-items-center justify-content-between">
            <TextStyles.FontSize20px className="font-weight-500">
              Client Info({client_id && client_id.company_name})
            </TextStyles.FontSize20px>
            <ClearIcon
              sx={{
                color: Colors.font2,
                cursor: "pointer",
                opacity: 0.7,
                "&:hover": {
                  opacity: 1,
                },
              }}
              onClick={handleClose}
            />
          </Modal.Header>
          <Modal.Body className="modal-body">
            <TextStyles.FontSize14px className="row">
              <div className="col-12 col-sm-6 mb-2">
                <label htmlFor="street_address" className="mb-2">
                  Street Address
                </label>
                <TextStyles.InputRectangle
                  invalid={errors.street}
                  id="street_address"
                  type="text"
                  placeholder="Street address"
                  name="street"
                  {...register("street")}
                />
              </div>
              <div className="col-12 col-sm-6 mb-2">
                <label htmlFor="suite_address" className="mb-2">
                  Suite Address
                </label>
                <TextStyles.InputRectangle
                  invalid={errors.suite}
                  id="suite_address"
                  type="text"
                  placeholder="suite address"
                  name="suite"
                  {...register("suite")}
                />
              </div>
            </TextStyles.FontSize14px>
            <TextStyles.FontSize14px className="row">
              <div className="col-12 col-sm-6 mb-2">
                <label htmlFor="city" className="mb-2">
                  City
                </label>
                <TextStyles.InputRectangle
                  invalid={errors.city}
                  id="city"
                  type="text"
                  placeholder="City"
                  name="city"
                  {...register("city")}
                />
              </div>
              <div className="col-12 col-sm-6 mb-2">
                <label htmlFor="zip_code" className="mb-2">
                  Zip Code
                </label>
                <TextStyles.InputRectangle
                  id="zip_code"
                  type="text"
                  placeholder="Zip Code"
                  name="zip_code"
                  {...register("zip_code")}
                />
              </div>
            </TextStyles.FontSize14px>
            <TextStyles.FontSize14px className="row">
              <div className="col-12 col-sm-6 mb-2">
                <label htmlFor="state" className="mb-2">
                  State
                </label>
                <TextStyles.InputRectangle
                  invalid={errors.state}
                  id="state"
                  type="text"
                  placeholder="State"
                  name="state"
                  {...register("state")}
                />
              </div>
              <div className="col-12 col-sm-6 mb-2">
                <label htmlFor="country" className="mb-2">
                  Country
                </label>
                <div>
                  <Controller
                    control={control}
                    id="country"
                    name="country"
                    render={({ field: { onChange, value } }) => (
                      <SelectCountry
                        placeholder="Select Country"
                        onChange={onChange}
                        defaultValue={value}
                      />
                    )}
                  />
                </div>
              </div>
            </TextStyles.FontSize14px>

            <TextStyles.FontSize14px className="row">
              <div className="col-12 col-sm-6 mb-2">
                <label htmlFor="tax_id_label" className="mb-2">
                  Tax Label
                </label>
                <TextStyles.InputRectangle
                  id="tax_id_label"
                  type="text"
                  placeholder="Tax label"
                  name="tax_id_label"
                  {...register("tax_id_label", {
                    pattern: {
                      value: /^[A-Za-z ]+$/, //only alphabets and space alowed
                      message: "Only letters and spaces are allowed",
                    },
                  })}
                />
                {errors.tax_id_label && (
                  <TextStyles.InValidFeedback>
                    {errors.tax_id_label.message}
                  </TextStyles.InValidFeedback>
                )}
              </div>
              <div className="col-12 col-sm-6 mb-2">
                <label htmlFor="tax_id_number" className="mb-2">
                  Tax ID
                </label>
                <TextStyles.InputRectangle
                  id="tax_id_number"
                  type="text"
                  placeholder="Tax ID"
                  name="tax_id_number"
                  {...register("tax_id_number", {
                    pattern: {
                      value: /^\S+$/, // no space alowed
                      message:
                        "Only letters, numbers and special characters are allowed",
                    },
                  })}
                />
                {errors.tax_id_number && (
                  <TextStyles.InValidFeedback>
                    {errors.tax_id_number.message}
                  </TextStyles.InValidFeedback>
                )}
              </div>
            </TextStyles.FontSize14px>
          </Modal.Body>
          <Modal.Footer style={{ display: "inline-block" }}>
            <div className="d-flex gap-3 justify-content-between">
              <TextStyles.CancelButton onClick={handleClose}>
                Cancel
              </TextStyles.CancelButton>
              <TextStyles.Button disabled={isLoading}>
                {isLoading ? <LoaderSpin /> : "Save"}
              </TextStyles.Button>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};

export default EditClientInfo;
